import React from 'react'
import { IWizardStepContext, StepName } from '../types'
import { notYetImplementedWithError } from '../../../utils'
import { ComponentWithChildren } from '../../../types'

export interface DescriptionStepFormData {
  title: string
  description: string
  price: number
  maxOccupancy: number
  minimumSessionLength: number
  bookingRules: string
}

const defaultInitialData = {
  title: '',
  description: '',
  price: 0,
  maxOccupancy: 2,
  minimumSessionLength: 30,
  bookingRules: ''
}

const DescriptionStepContext = React.createContext<IWizardStepContext<DescriptionStepFormData>>({
  name: StepName.Description,
  data: defaultInitialData,
  setStepData: notYetImplementedWithError,
  validateStepData: notYetImplementedWithError
})

interface DescriptionStepProviderProps extends ComponentWithChildren {
  initialData?: DescriptionStepFormData
}

export const DescriptionStepProvider: React.FC<DescriptionStepProviderProps> = ({ children, initialData }) => {
  const [formData, setFormData] = React.useState<DescriptionStepFormData>(initialData ?? defaultInitialData)

  const value = React.useMemo<IWizardStepContext<DescriptionStepFormData>>(() => {
    const setStepFormData = (formData: DescriptionStepFormData): void => {
      setFormData(formData)
    }

    const validateStepData = (): void => {
      if (formData.title.length === 0) {
        throw new Error('Title is required')
      }
      if (formData.description.length === 0) {
        throw new Error('Description is required')
      }
      if (formData.price <= 0) {
        throw new Error('Price must be greater than 0')
      }
      if (formData.maxOccupancy <= 0) {
        throw new Error('Max Occupancy must be greater than 0')
      }
      if (formData.minimumSessionLength <= 0) {
        throw new Error('Minimum session length must be greator than 0')
      }
    }

    return {
      name: StepName.Description,
      data: formData,
      setStepData: setStepFormData,
      validateStepData
    }
  }, [formData])

  return (
    <DescriptionStepContext.Provider value={value}>
      {children}
    </DescriptionStepContext.Provider>
  )
}

export default DescriptionStepContext
